<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <Forms
          ref="frmGroup"
          :title="'CONFIGURAÇÃO AMBIENTE'"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="clearInputs"
          v-on:Save="submitFile"
        >
          <div>
            <h4>Tela de Login:</h4>
            <hr />
            <div style="display: flex; gap: 1.5rem">
              <FormulateInput
                class="lg-formulate-input"
                v-model="posicao"
                placeholder="Selecione a posição"
                label="Posição do Menu de Login:"
                type="select"
                :options="['ESQUERDA', 'CENTRO', 'DIREITA']"
                name="logoPosition"
              />
              <div style="display: flex; flex-direction: row; width: 75%; gap: 1rem;" >
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="background"
                    @input="uploadBackground"
                    label="Selecione Imagem de Fundo:"
                    type="file"
                    accept=".jpeg,.jpg,.png"
                    name="backgroundImage"
                    validation="mime:image/jpeg,image/jpg,image/png"
                    :validation-messages="this.imagemFundoValidationMessage"
                  />
                  <small v-if=background>{{ this.background.name }}</small>
                </div>
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="logo"
                    @input="uploadLogo(logo, 'logo')"
                    label="Selecione a Logo:"
                    type="file"
                    accept=".jpeg,.jpg,.png,.svg"
                    name="logoImage"
                    validation="mime:image/jpeg,image/jpg,image/png,image/svg+xml"
                    :validation-messages="this.logoValidationMessage"
                  />
                  <small v-if=logo>{{ this.logo.name }}</small>
                </div>
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="reportLogo"
                    @input="uploadLogo(reportLogo, 'reportLogo')"
                    label="Selecione a Logo para Relatórios pdf:"
                    type="file"
                    accept=".jpeg,.jpg,.png,.svg"
                    help="Tamanhos máximos recomendados: 300px x 200px"
                    name="logoReportImage"
                    validation="mime:image/jpeg,image/jpg,image/png,image/svg+xml"
                    :validation-messages="this.logoValidationMessage"
                  />
                  <small v-if=logo>{{ this.reportLogo.name }}</small>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h4>Logo de menu lateral</h4>
            <hr />
            <div style="display: flex; gap: 1.5rem">
              <div style="display: flex; flex-direction: row; width: 100%; gap: 1rem;" >
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="sidebarLogoDesktop"
                    @input="uploadLogo(sidebarLogoDesktop, 'sidebarLogoDesktop')"
                    label="Desktop"
                    type="file"
                    accept=".jpeg,.jpg,.png,.svg"
                    name="sidebarLogoDesktop"
                    help="Tamanho renderizado: 150px x 50px"
                    validation="mime:image/jpeg,image/jpg,image/png,image/svg+xml"
                    :validation-messages="this.logoValidationMessage"
                  />
                  <small v-if=sidebarLogoDesktop>{{ this.sidebarLogoDesktop.name }}</small>
                </div>
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="sidebarLogoTablet"
                    @input="uploadLogo(sidebarLogoTablet, 'sidebarLogoTablet')"
                    label="Tablet"
                    type="file"
                    accept=".jpeg,.jpg,.png,.svg"
                    name="sidebarLogoTablet"
                    help="Tamanho renderizado: 150px x 50px"
                    validation="mime:image/jpeg,image/jpg,image/png,image/svg+xml"
                    :validation-messages="this.logoValidationMessage"
                  />
                  <small v-if=sidebarLogoTablet>{{ this.sidebarLogoTablet.name }}</small>
                </div>
                <div style="flex: 1;">
                  <NxInput style="width: 100%;"
                    v-model="sidebarLogoMobile"
                    @input="uploadLogo(sidebarLogoMobile, 'sidebarLogoMobile')"
                    label="Mobile"
                    type="file"
                    accept=".jpeg,.jpg,.png,.svg"
                    name="sidebarLogoMobile"
                    help="Tamanho renderizado: 150px x 50px"
                    validation="mime:image/jpeg,image/jpg,image/png,image/svg+xml"
                    :validation-messages="this.logoValidationMessage"
                  />
                  <small v-if=sidebarLogoMobile>{{ this.sidebarLogoMobile.name }}</small>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 1rem">
            <h4>Gestão de acesso:</h4>
            <hr />
            <FormulateInput
              class="lg-formulate-input"
              v-model="tipoPermissao"
              placeholder="Selecione o tipo de gestão"
              label="Selecione o tipo de gestão:"
              type="select"
              :options="this.gestaoOptions"
              name="tipoPermissao"
            />
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchSuperTela">Liberar supertela em associado?</label>
              <ToogleSwitch
                id="ToogleSwitchSuperTela"
                v-model="enableAssociateResume"
              />
            </div>
          </div>
          <div style="margin-top: 1rem">
            <h4>Gestão de Atendimento</h4>
            <hr />
            <FormulateInput
              class="lg-formulate-input"
              v-model="tipoAtendimento"
              placeholder="O cooperado será atendido por..."
              label="Selecione o tipo de gestão:"
              type="select"
              :options="{
                CENTRAL_PA: 'PELA CENTRAL DO PA',
                AGENTE_RELACIONAMENTO: 'PELO AGENTE DE RELACIONAMENTO',
                GERENTE_CARTEIRA: 'PELO GERENTE DA CARTEIRA'
              }"
              name="tipoAtendimento"
            />
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchNPS">O usuário deve ter NPS?</label>
              <ToogleSwitch
                id="ToogleSwitchNPS"
                v-model="npsStatus"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchPA">Identificar PA pelo documento?</label>
              <ToogleSwitch
                id="ToogleSwitchPA"
                v-model="identificarPa"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchAudio">Liberar audio?</label>
              <ToogleSwitch
                id="ToogleSwitchAudio"
                v-model="enableAudioAtendimento"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchMensagens"
                >Mensagens Automáticas (Boas vindas e horário)?</label
              >
              <ToogleSwitch
                id="ToogleSwitchMensagens"
                v-model="mensagensAutomaticas"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchMensagens"
                >Identificar PA Pelo Celular?</label
              >
              <ToogleSwitch
                id="ToogleSwitchMensagens"
                v-model="identifyPaNumber"
              />
            </div>
          </div>
          <div style="margin-top: 3rem">
            <h4>Configurações de senha:</h4>
            <hr />
            <div style="display: flex; width: 100%; gap: 1rem">
              <div style="width: 100%">
                <label for="ToogleSwitchPassword"
                  >A senha dos usuários deve expirar periodicamente?</label
                >
                <ToogleSwitch
                  id="ToogleSwitchPassword"
                  v-model="passwordWillExpire"
                />
              </div>
              <FormulateInput
                class="lg-formulate"
                v-if="passwordWillExpire"
                v-model="daysToExpire"
                label="Qual o período em dias?"
                type="range"
                name="range"
                min="15"
                max="180"
                validation="required|min:15|max:180"
                :validation-messages="this.periodoValidationMessage"
                error-behavior="live"
                :show-value="true"
              />
            </div>
            <div
              style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
            >
              <div style="width: 100%">
                <label for="ToogleSwitchBlocked"
                  >O usuário deve ter sua conta bloqueada após múltiplas
                  tentativas incorretas?</label
                >
                <ToogleSwitch
                  id="ToogleSwitchBlocked"
                  v-model="accountWillBlock"
                />
              </div>
              <FormulateInput
                class="lg-formulate"
                v-if="accountWillBlock"
                v-model="attemptsToBlock"
                label="Qual o número máximo de tentativas?"
                type="range"
                name="range"
                min="3"
                max="10"
                validation="required|min:3|max:10"
                :validation-messages="this.tentativasValidationMessage"
                error-behavior="live"
                :show-value="true"
              />
            </div>
            <div style="margin-top: 1rem">
              <FormulateInput
                class="lg-formulate-input"
                @change="hasClasseA($event.target.value)"
                v-model="typeSenderMFA"
                placeholder="Selecione o tipo de envio do MFA"
                label="Selecione o tipo de envio do MFA:"
                type="select"
                :options="{ EMAIL: 'EMAIL', SMS: 'SMS' }"
                name="typeSenderMFA"
              />
            </div>
          </div>
        </Forms>
      </div>
    </div>
    <div v-if="hasWaitUpload">
      <div class="upload"></div>
      <div class="uploadText">
        <h2>
          <i class="fas fa-file-import"></i> Upload iniciado! <br />Aguarde um
          momento, por favor.<br />
          <small style="font-size: 12px; padding-top: 10px"
            >Essa mensagem será fechada ao final!</small
          >
        </h2>
      </div>
      <div class="upload-loading">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="upload-loading-img"
          width="200px"
          height="200px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="translate(20 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#006a5b"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.375s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(40 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#04a791"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.25s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(60 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#abbd81"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.125s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(80 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#d1ddb5"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="0s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
        </svg>
        <div class="text-center">
          <strong>Acompanhe abaixo o envio do arquivo:</strong>
          <url
            class="pt-3"
            v-for="(obj, index) in uploadingFiles"
            :key="index"
          >
            <li
              v-if="obj.uploaded"
              class="pt-2"
            >
              <i class="far fa-file-excel excel-color"></i> {{ obj.file.name }}
              <i class="fas fa-check excel-color"></i>
            </li>
            <li
              v-else
              class="pt-2"
            >
              <i class="fas fa-upload text-third"></i> Enviando
              {{ obj.file.name }}
              <b-spinner
                small
                label="Aguarde..."
                variant="success"
              ></b-spinner>
            </li>
          </url>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'
import ParametroClasseA from '@/shared/http/repositories/configurations/parametroClasseA'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'Environment',
  mixins: [ActionsForm],
  data () {
    return {
      background: null,
      logo: null,
      reportLogo: null,
      sidebarLogoDesktop: null,
      sidebarLogoTablet: null,
      sidebarLogoMobile: null,
      posicao: null,
      tipoPermissao: null,
      tipoAtendimento: null,
      passwordWillExpire: false,
      daysToExpire: null,
      accountWillBlock: false,
      enableAssociateResume: false,
      npsStatus: false,
      identificarPa: false,
      enableAudioAtendimento: true,
      mensagensAutomaticas: false,
      identifyPaNumber: false,
      attemptsToBlock: null,
      typeSenderMFA: null,
      imagemFundoValidationMessage: {
        mime: 'A imagem deve estar em JPEG, JPG ou PNG'
      },
      logoValidationMessage: {
        mime: 'A imagem deve estar em JPEG, JPG, PNG ou SVG'
      },
      gestaoOptions: {
        GERENTE: this.$t('associates.gerenteSisbr').toUpperCase(),
        GERENTERELACIONAMENTO: 'GERENTE RELACIONAMENTO'
      },
      periodoValidationMessage: {
        required: 'Escolha o período em dias.',
        min: 'Mínimo de 15 dias'
      },
      tentativasValidationMessage: {
        required: 'Escolha a quantidade limite.',
        min: 'Mínimo de 3 tentativas'
      },
      uploadedImageSizeCapInBytes: 5120000, // 5mb
      uploadedBackgroundImageAcceptableFormats: ['image/png', 'image/jpeg', 'image/jpg'],
      uploadedLogoImageAcceptableFormats: ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml']
    }
  },
  components: {
    ToogleSwitch
  },
  computed: {
    hasWaitUpload () {
      return this.waitUpload
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      EnvironmentRepository.getEnv()
        .then((res) => {
          let response = res.data

          this.posicao = response.posicao
          this.tipoPermissao = response.tipoPermissao
          this.tipoAtendimento = response.tipoAtendimento
          this.npsStatus = response.npsStatus === 1
          this.enableAssociateResume = response.enableAssociateResume
          this.identificarPa = response.identificarPa === 1
          this.enableAudioAtendimento = response.enableAudioAtendimento
          this.mensagensAutomaticas = response.mensagensAutomaticas === 1
          this.identifyPaNumber = response.identifyPaNumber === 1
          this.background = response.hasBackground
          this.logo = response.hasLogo
          this.reportLogo = response.hasReportLogo
          this.sidebarLogoDesktop = response.hasSidebarLogoDesktop
          this.sidebarLogoTablet = response.hasSidebarLogoTablet
          this.sidebarLogoMobile = response.hasSidebarLogoMobile

          // BACK RETURNS DAYS > 0 IF THE FEAT IS ON
          if (response.daysPwdExpire > 0) {
            this.passwordWillExpire = true
            this.daysToExpire = response.daysPwdExpire
          }
          if (response.maxLoginAttempts > 0) {
            this.accountWillBlock = true
            this.attemptsToBlock = response.maxLoginAttempts
          }

          this.typeSenderMFA = response.typeSenderMFA
        })
        .catch((err) => console.error(err))
    },
    uploadBackground (image) {
      let sizeIsValid = this.validateImageSize(image, this.uploadedImageSizeCapInBytes)
      if (!sizeIsValid) {
        this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Imagem de background inválida.<br>Tamanho máximo aceitável é 5mb.')
        return
      }
      let typeIsValid = this.validateImageType(image, this.uploadedBackgroundImageAcceptableFormats)
      if (!typeIsValid) {
        this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Imagem de background inválida.<br>Tipos aceitáveis são .png, .jpg e .jpeg.')
        return
      }
      if (!this.background) return
      this.background = image.files[0].file
    },
    /**
     * Sets sent image on local variables and prepares for sending to backend. Returns void.
     * @param image Image object
     * @param logoType String
     */
    uploadLogo (image, logoType) {
      let sizeIsValid = this.validateImageSize(image, this.uploadedImageSizeCapInBytes)
      if (!sizeIsValid) {
        this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Imagem de logo inválida.<br>Tamanho máximo aceitável é 5mb.')
        return
      }
      let typeIsValid = this.validateImageType(image, this.uploadedLogoImageAcceptableFormats)
      if (!typeIsValid) {
        this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Imagem de logo inválida.<br>Tipos aceitáveis são .png, .jpg e .jpeg.')
        return
      }
      if (logoType === 'logo') {
        if (!this.logo) return
        this.logo = image.files[0].file
      } else if (logoType === 'reportLogo') {
        if (!this.reportLogo) return
        this.reportLogo = image.files[0].file
      } else if (logoType === 'sidebarLogoDesktop') {
        if (!this.sidebarLogoDesktop) return
        this.sidebarLogoDesktop = image.files[0].file
      } else if (logoType === 'sidebarLogoTablet') {
        if (!this.sidebarLogoTablet) return
        this.sidebarLogoTablet = image.files[0].file
      } else if (logoType === 'sidebarLogoMobile') {
        if (!this.sidebarLogoMobile) return
        this.sidebarLogoMobile = image.files[0].file
      }
    },
    submitFile () {
      this.waitUpload = true
      const formData = new FormData()
      const importData = {
        posicao: this.posicao,
        tipoPermissao: this.tipoPermissao,
        tipoAtendimento: this.tipoAtendimento,
        daysPwdExpire:
          this.daysToExpire && this.passwordWillExpire ? this.daysToExpire : 0,
        maxLoginAttempts:
          this.attemptsToBlock && this.accountWillBlock
            ? this.attemptsToBlock
            : 0,
        enableAssociateResume: this.enableAssociateResume,
        npsStatus: this.npsStatus ? 1 : 0,
        enableAudioAtendimento: this.enableAudioAtendimento,
        identificarPa: this.identificarPa ? 1 : 0,
        mensagensAutomaticas: this.mensagensAutomaticas ? 1 : 0,
        identifyPaNumber: this.identifyPaNumber ? 1 : 0,
        hasLogo: true,
        hasReportLogo: true,
        hasBackground: true,
        hasSidebarLogoDesktop: true,
        hasSidebarLogoTablet: true,
        hasSidebarLogoMobile: true,
        typeSenderMFA: this.typeSenderMFA
      }
      let json = new Blob([JSON.stringify(importData)], {
        type: 'application/json'
      })

      if (this.background) formData.append('background', this.background)
      if (this.logo) formData.append('logo', this.logo)
      if (this.reportLogo) formData.append('reportLogo', this.reportLogo)
      if (this.sidebarLogoDesktop) formData.append('sidebarLogoDesktop', this.sidebarLogoDesktop)
      if (this.sidebarLogoTablet) formData.append('sidebarLogoTablet', this.sidebarLogoTablet)
      if (this.sidebarLogoMobile) formData.append('sidebarLogoMobile', this.sidebarLogoMobile)
      formData.append('data', json)

      EnvironmentRepository.Update(formData)
        .then(() => {
          toast.success('Ambiente alterado')
          this.$router.replace({ name: 'PaginaInicial' })
        })
        .catch(() => {
          this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Erro ao salvar configurações. Revise os dados enviados.')
        })
    },
    clearInputs () {
      this.logo = null
      this.reportLogo = null
      this.background = null
      this.sidebarLogoDesktop = null
      this.sidebarLogoTablet = null
      this.sidebarLogoMobile = null
      this.tipoPermissao = null
      this.tipoAtendimento = null
      this.posicao = 'ESQUERDA'
      this.typeSenderMFA = null
      this.enableAssociateResume = false
      this.npsSatus = false
      this.identificarPa = false
      this.enableAudioAtendimento = false
      this.mensagensAutomaticas = false
      this.identifyPaNumber = false
    },
    hasClasseA (val) {
      if (val === 'SMS') {
        ParametroClasseA.GetAll().then((response) => {
          if (!response.data || !response.data.usuario) {
            toast.warning('Parametros de Classe A não cadastrados no sistema')
            this.typeSenderMFA = 'EMAIL'
          }
        })
      }
    },
    /**
     * Validates if uploaded image's format is acceptable. Returns: bool.
     * @param imageFile
     * @param acceptableFormatsArray array[string]
     */
    validateImageType (imageFile, acceptableFormatsArray) {
      return (acceptableFormatsArray.includes(imageFile.files[0].file.type))
    },
    /**
     * Validates if uploaded image's size in bytes is acceptable. Returns: bool.
     * @param imageFile
     * @param sizeCapInBytes Integer number
     */
    validateImageSize (imageFile, sizeCapInBytes) {
      return imageFile.files[0].file.size <= sizeCapInBytes
    }
  }
}
</script>

<style scoped>
.lg-formulate {
  width: 100% !important;
}
.formulate-input {
  width: 50%;
}
.formulate-input-element {
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/environment/envinronment.vue